import * as React from 'react';
import { Link, Switch, Route } from 'react-router-dom';
import './Menu.css';
import clsx from 'clsx';
import { makeStyles, useTheme, Theme, createStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { VideoLibrary, DeveloperBoard, Home } from '@material-ui/icons';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Canvas from './components/canvas/Canvas'
import Video from './components/video/Video';
import HomePage from './components/home/Home';
import { _PortalState } from './helpers/state';
import { Button, Container } from '@material-ui/core';
import Videos from './components/video/Videos';

const Main = () => (
  <Switch>
    <Route exact={true} path='/' component={HomePage} />
    <Route exact={true} path='/video' component={Videos} />
    <Route exact={true} path='/video/:id' component={Video} />
    <Route exact={true} path='/canvas/:group' component={Canvas} />
  </Switch>
);

const drawerWidth = 320;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      backgroundColor: '#0398ea'
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: '0 8px',
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
    },
    content: {
      width: 'auto',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
        // width: 600,
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
      },
      marginTop: '50px',
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    container: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(4),
    },
  }),
);

const Menu = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  // const VideosAvailable = groups.some(g => g.GroupId === 'ee9e3f65-be50-4c07-9994-1f681ff87623');
  const BoardsAvailable = _PortalState.groups.some(g => g.GroupId !== 'ee9e3f65-be50-4c07-9994-1f681ff87623');

  function handleDrawerOpen() {
    setOpen(true);
  }

  function handleDrawerClose() {
    setOpen(false);
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <div style={{ display: 'flex', margin: 'auto' }} >
            <img src="./images/bw.png" style={{ height: '60px', marginRight: '10px' }} />
            <div className="appbar-header-title">
              <Typography variant="h6" noWrap={true} style={{ paddingTop: '15px' }}>BW Ventures</Typography>
              {_PortalState.ApiEndpoint === 'https://bwventures-api.azurewebsites.net' &&
                <Typography variant="h6" noWrap={true} style={{ paddingTop: '15px' }}>** Test environment **</Typography>
              }
            </div >

          </div>

          <Button onClick={() => _PortalState.authProvider.logout()} color="inherit">Logout</Button>

        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        // variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <Divider />
        <List>
          <ListItem component={Link} to="/" button={true} onClick={() => handleDrawerClose()}>
            <ListItemIcon><Home /></ListItemIcon>
            <ListItemText primary="Home" />
          </ListItem>
        </List>
        <Divider />
        {_PortalState.groups &&
          <List>
            <ListItem button={false}>
              <ListItemText primary="Canvasses" />
            </ListItem>

            {_PortalState.groups.filter(g => g.GroupId !== 'ee9e3f65-be50-4c07-9994-1f681ff87623').map(g => {
              return (
                <ListItem key={g.GroupId} component={Link} to={"/canvas/" + g.GroupId} button={true} onClick={() => handleDrawerClose()}>
                  <ListItemIcon><DeveloperBoard /></ListItemIcon>
                  <ListItemText primary={g.GroupName} />
                </ListItem>
              );
            })}

            {!BoardsAvailable &&
              <ListItem component={Link} button={false}>
                <ListItemText secondary="There are no canvasses shared with you" />
              </ListItem>
            }

          </List>
        }
        <Divider />
        <List>
          <ListItem component={Link} to="/video" button={true} onClick={() => handleDrawerClose()}>
            <ListItemIcon><VideoLibrary /></ListItemIcon>
            <ListItemText primary="Videos" />
          </ListItem>
        </List>

        {/* <List>
          <ListItem button={false}>
            <ListItemText primary="Videos" />
          </ListItem>

          {videos && VideosAvailable &&
            videos.map(v => {
              return (
                <ListItem key={v.id} component={Link} to={"/video/" + v.id} button={true} onClick={() => handleDrawerClose()}>
                  <ListItemIcon><VideoLibrary /></ListItemIcon>
                  <ListItemText primary={v.Title} />
                </ListItem>
              );
            })
          }
          {!VideosAvailable &&
            <ListItem component={Link} button={false}>
              <ListItemText secondary="You have no video subscription" />
            </ListItem>
          }
        </List>
        <Divider /> */}
      </Drawer>
      <main
        className={clsx(classes.content)}
      >
        {/* <div className={classes.drawerHeader} /> */}
        <Container maxWidth='lg' className={classes.container}>
          {/* <Grid container={true} spacing={3}> */}

          <Main />

          {/* </Grid> */}
        </Container>



      </main>
    </div>
  );

}

export default Menu;



// WEBPACK FOOTER //
// ./src/Menu.tsx